import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import MainContainer from "../controls/MainContainer";
import Routes from "./Routes";

const styles = () => ({
  root: {
    display: "flex",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    position: "relative"
  },

  content: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minWidth: 0,
    minHeight: 0,
    height: "100%"
  }
});

class Home extends Component {
  state = {
    mobileOpen: false
  };

  handleDrawerToggle = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen
    });
  };

  render() {
    const { classes } = this.props;
    const { mobileOpen } = this.state;

    const shouldRenderMobileMenu =
      this.props.history.location.pathname === "/sale";

    return (
      <div className={classes.root}>
        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={this.handleDrawerToggle}
        />

        <div className={classes.content}>
          <Header
            shouldRenderMobileMenu={shouldRenderMobileMenu}
            handleDrawerToggle={this.handleDrawerToggle}
          />

          <MainContainer
            shouldRenderMobileMenu={shouldRenderMobileMenu}
          >
            <Routes />
          </MainContainer>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(Home));
